export default [
  { label: "Default", value: "DEFAULT" },
  { label: "Double", value: "DOUBLE_QK" },
  { label: "Single", value: "SINGLE_DK" },
  { label: "Twin", value: "DOUBLE_DOUBLE" },
  { label: "Triple", value: "TRIPLE" },
  { label: "Quad", value: "QUAD" },
];
